/**
 * useResizeObserver
 * 
 * @Author: Focci
 * @Date: 2024-11-06 16:25:18
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-06 16:25:18
 */

// import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

const defaultValue = { width: 0, height: 0 }

export default function useResizeObserver(element) {
  const [size, setSize] = useState(defaultValue)

  useEffect(() => {
    if(element) {
      const resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0]
        const { width, height } = entry?.contentRect || defaultValue
        setSize({ width, height })
      })
      
      resizeObserver.observe(element)
    }
  }, [element])

  return size
}
